import React from 'react';
import { Layout } from '../../components/layout/Layout';
import { PageHero, ContentSection, SEOContent, CTASection } from '../../components/shared';

export const HerzCheckPage = () => {
  return (
    <Layout>
      <PageHero
        title="Herz-Check (Basis-Check)"
        subtitle="Vorsorgeuntersuchung für ein sicheres Gefühl rund um Ihr Herz."
        backgroundImage="/images/Kardiologie 2.webp"
        ctaText="Herz-Check buchen"
      />

      <ContentSection
        title="Wann ist ein Herz-Check sinnvoll?"
        content="Ein Herz-Check empfiehlt sich bei Bluthochdruck, familiärer Vorbelastung, Belastungsbeschwerden oder zur allgemeinen Vorsorge. Auch bei unklaren Beschwerden wie Herzstolpern, Kurzatmigkeit oder Brustschmerzen sollten Sie Ihr Herz untersuchen lassen."
        image="/images/Kardiologie 2.webp"
        backgroundColor="white"
      />

      <ContentSection
        title="Was wird untersucht?"
        content="Je nach Fragestellung kombinieren wir Gespräch, körperliche Untersuchung, Ruhe-EKG, Blutdruckmessung und weitere Untersuchungen. Bei Bedarf können Belastungs-EKG, Herzultraschall oder Laborwerte ergänzt werden."
        image="/images/EKG_neu.webp"
        imagePosition="left"
        backgroundColor="gray"
      />

      <SEOContent
        title="Herz-Check Diez"
        content="Basis-Herz-Check und kardiologische Vorsorge im Medicum Diez – persönlich, modern und koordiniert mit den Hausärzten im Rhein-Lahn-Kreis."
      />

      <CTASection
        title="Herz-Check vereinbaren"
        subtitle="Vereinbaren Sie Ihren Termin zur kardiologischen Vorsorge online oder telefonisch."
        buttonText="Termin buchen"
      />
    </Layout>
  );
};


